import React from 'react';
import { MdHelpOutline, MdKeyboardArrowDown } from 'react-icons/md';

const FAQs = () => {
    const faqItems = [
        {
            question: 'What is Omni Trade Beacon?',
            answer: 'Omni Trade Beacon is your ultimate guide to top trading platforms for stocks and cryptocurrencies. We provide comprehensive information on the best platforms to help you make informed trading decisions.'
        },
        {
            question: 'What platforms do you feature?',
            answer: 'We feature a curated list of leading trading platforms such as Binance, Coinbase, Robinhood, E*TRADE, TD Ameritrade, Kraken, Fidelity, WeBull, Bitfinex, and Huobi. Each platform is reviewed based on its features, user experience, and reliability.'
        },
        {
            question: 'How can I choose the right platform?',
            answer: 'Choosing the right platform depends on your trading needs and preferences. Consider factors such as fees, available assets, ease of use, and advanced trading tools. Our reviews provide detailed insights to help you select the best option for you.'
        },
        {
            question: 'Are the platforms featured on Omni Trade Beacon reliable?',
            answer: 'Yes, we carefully select and review each platform based on its reputation, features, and user feedback. Our goal is to ensure that you have access to trustworthy and high-quality trading options.'
        },
        {
            question: 'How often is the information updated?',
            answer: 'We regularly update our information to reflect the latest features, fees, and changes related to the platforms we feature. Check back frequently to stay informed about the top trading options available.'
        }
    ];

    return (
        <div style={{ fontFamily: 'Arial, sans-serif', padding: '20px', backgroundColor: '#121212', color: '#e0e0e0' }}>
            <header style={{ textAlign: 'center', marginBottom: '30px' }}>
                <h1 style={{ fontSize: '2.5em', color: '#e0e0e0' }}>Frequently Asked Questions</h1>
            </header>

            <section style={{ margin: '0 auto', padding: '0 20px' }}>
                {faqItems.map((item, index) => (
                    <div key={index} style={{ marginBottom: '20px', borderBottom: '1px solid #333', paddingBottom: '15px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                            <MdHelpOutline style={{ fontSize: '1.5em', color: '#e0e0e0', marginRight: '10px' }} />
                            <h2 style={{ fontSize: '1.5em', color: '#e0e0e0', margin: 0 }}>{item.question}</h2>
                            <MdKeyboardArrowDown style={{ fontSize: '1.2em', color: '#b0b0b0', marginLeft: '10px' }} />
                        </div>
                        <p style={{ fontSize: '1.1em', color: '#b0b0b0', lineHeight: '1.6' }}>{item.answer}</p>
                    </div>
                ))}
            </section>
            
            <footer style={{ textAlign: 'center', padding: '20px 0', borderTop: '1px solid #333', marginTop: '30px' }}>
                <p style={{ fontSize: '1em', color: '#b0b0b0' }}>© 2024 Omni Trade Beacon. All Rights Reserved.</p>
            </footer>
        </div>
    );
}

export default FAQs;
